import { SvgWeb } from "@web-app/public/images/svg/SvgWeb";
import { FilterCardMenuItem } from "./FilterCardMenuItem";

const EventDataTypes = ["all", "events", "places"] as const;
export type EventDataType = (typeof EventDataTypes)[number];

type FilterCardMenuProps = {
  activeData: EventDataType;
  setActiveData: (data: EventDataType) => void;
};

export const FilterCardMenu = ({
  activeData,
  setActiveData,
}: FilterCardMenuProps) => {
  const isItemSelected = (itemName: EventDataType) => {
    return itemName === activeData;
  };

  const onSelected = (itemName: EventDataType) => {
    setActiveData(itemName);
  };

  return (
    <>
      {/* <FilterCardMenuItem
        isSelected={isItemSelected("all")}
        title="Tout voir"
        onKeyDown={() => setActiveData("all")}
        onSelected={() => onSelected("all")}
      /> */}
      <FilterCardMenuItem
        isSelected={isItemSelected("events")}
        title="Événements"
        onKeyDown={() => setActiveData("events")}
        onSelected={() => onSelected("events")}
      >
        <SvgWeb
          name="ticket"
          alt={"ticket"}
          isColored={isItemSelected("events")}
          width={24}
          height={24}
        />
      </FilterCardMenuItem>
      {/* <FilterCardMenuItem
        isSelected={isItemSelected("places")}
        title="Lieux touristiques"
        onKeyDown={() => setActiveData("places")}
        onSelected={() => onSelected("places")}
      >
        <SvgWeb
          isColored={isItemSelected("places")}
          name="mapIn"
          alt={"map"}
          width={24}
          height={24}
        />
      </FilterCardMenuItem> */}
    </>
  );
};
